import clsx from 'clsx'
import Box from '@mui/material/Box'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  previewContainer: {
    width: '100%',
    height: 100,
    overflowX: 'auto',
    overflowY: 'hidden',
    margin: theme.spacing(2, 0),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  imgPrev: {
    width: 100,
    minWidth: 100,
    maxWidth: 100,
    height: 80,
    background: theme.palette.lightGray.main,
    float: 'left',
    cursor: 'pointer',
    position: 'relative',
    margin: theme.spacing(0, 1),
    '& > img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    '&::after': {
      display: 'none',
      content: '""',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      border: '2px solid',
      borderColor: theme.palette.primary.main,
    },
  },
  selectedImg: {
    '&::after': {
      display: 'block',
    },
  },
}))

const CarouselPreview = ({
  imageList,
  setCurrentImageIndex,
  currentImageIndex,
}) => {
  const classes = useStyles()
  return (
    <Box className={classes.previewContainer}>
      {imageList.map((imgInfo, index) => (
        <Box
          onClick={() => setCurrentImageIndex(index)}
          key={imgInfo.id}
          id={imgInfo.id}
          className={clsx({
            [classes.imgPrev]: true,
            [classes.selectedImg]: Boolean(index === currentImageIndex),
          })}
        >
          <img src={imgInfo.image} alt="" />
        </Box>
      ))}
    </Box>
  )
}

export default CarouselPreview
